import {
  Component,
  OnInit,
  Inject,
  OnDestroy,
  ElementRef,
  ViewChild,
} from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, OperatorFunction } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  map,
  filter,
  tap,
} from 'rxjs/operators';
import { hostArrivedPackValidator } from 'src/app/directives/hostArrivedPackValidator.directive';
import { ExchangeRateService } from 'src/app/services/exchange-rate.service';
import { ToastrService } from 'ngx-toastr';
type HtsContent = { id: number; content: string };
@Component({
  selector: 'dialog-editItemForCustoms',
  templateUrl: 'edit-custom-item-dialog.html',
})
export class EditItemForCustomsDialog implements OnDestroy, OnInit {
  notFoundedItem = false;
  htsList: HtsContent[] = [];
  formatter = (state: HtsContent) => state.content;
  search: OperatorFunction<string, readonly { id; content }[]> = (
    text$: Observable<string>
  ) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      filter((term) => term.length >= 1),
      map((term) =>
        this.htsList
          .filter((state) => new RegExp(term, 'mi').test(state.content))
          .slice(0, 10)
      ),
      tap((res) =>
        res.length > 0
          ? (this.notFoundedItem = false)
          : (this.notFoundedItem = true)
      )
    );

  editCustomsItemForm = new UntypedFormGroup({
    description: new UntypedFormControl('', Validators.required),
    origin_country: new UntypedFormControl('', [
      Validators.required,
      Validators.minLength(2),
      Validators.maxLength(2),
    ]),
    quantity: new UntypedFormControl(0, [
      Validators.required,
      Validators.min(1),
    ]),
    weight: new UntypedFormControl(0, [
      Validators.required,
      hostArrivedPackValidator(),
    ]),
    value: new UntypedFormControl(0, [
      Validators.required,
      hostArrivedPackValidator(),
    ]),
    currency: new UntypedFormControl('USD', [
      Validators.required,
      Validators.minLength(3),
      Validators.maxLength(3),
    ]),
    hs_tariff_number: new UntypedFormControl('', Validators.required),
    productIdentifier: new UntypedFormControl(''),
  });
  constructor(
    public dialogRef: MatDialogRef<EditItemForCustomsDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private exchangeRateService: ExchangeRateService,
    private toastr: ToastrService
  ) {}
  ngOnInit(): void {
    this.editCustomsItemForm.patchValue({
      description: this.data.item.description,
      origin_country: this.data.item.origin_country,
      quantity: this.data.item.quantity,
      weight: this.data.item.weight,
      value: this.data.item.value,
      currency: this.data.item.currency,
      hs_tariff_number: this.data.item.hs_tariff_number,
      productIdentifier: this.data.item.productIdentifier,
    });
    this.htsList = this.data.htsList;

    // this.editCustomsItemForm.controls.currency.disable()
  }
  closeWithoutAddItem(): void {
    this.editCustomsItemForm.reset();
    this.dialogRef.close();
  }
  checkInputValidationsAddItem() {
    var hasError = false;
    if (this.editCustomsItemForm.controls.description.status == 'INVALID') {
      this.editCustomsItemForm.controls.description.markAsTouched();
      hasError = true;
    }
    if (this.editCustomsItemForm.controls.origin_country.status == 'INVALID') {
      this.editCustomsItemForm.controls.origin_country.markAsTouched();
      hasError = true;
    }
    if (this.editCustomsItemForm.controls.quantity.status == 'INVALID') {
      this.editCustomsItemForm.controls.quantity.markAsTouched();
      hasError = true;
    }
    if (this.editCustomsItemForm.controls.weight.status == 'INVALID') {
      this.editCustomsItemForm.controls.weight.markAsTouched();
      hasError = true;
    }
    if (this.editCustomsItemForm.controls.value.status == 'INVALID') {
      this.editCustomsItemForm.controls.value.markAsTouched();
      hasError = true;
    }
    if (this.editCustomsItemForm.controls.currency.status == 'INVALID') {
      this.editCustomsItemForm.controls.currency.markAsTouched();
      hasError = true;
    }
    if (
      this.editCustomsItemForm.controls.hs_tariff_number.status == 'INVALID'
    ) {
      this.editCustomsItemForm.controls.hs_tariff_number.markAsTouched();
      hasError = true;
    }
    if (
      this.editCustomsItemForm.controls.productIdentifier.status == 'INVALID'
    ) {
      this.editCustomsItemForm.controls.productIdentifier.markAsTouched();
      hasError = true;
    }
    return hasError;
  }

  onEditItem() {
    if (!this.checkInputValidationsAddItem()) {
      if (this.editCustomsItemForm.controls.currency.value === 'EUR') {
        this.exchangeRateService.getExchangeRate().subscribe({
          next: (res: any) => {
            const rate = res['rates']['USD'];
            this.editCustomsItemForm.controls.value.setValue(
              parseFloat((this.editCustomsItemForm.controls.value.value * rate).toFixed(2))
            );
            this.editCustomsItemForm.controls.currency.setValue('USD');
            this.editCustomsItemForm.controls.currency.enable();
            this.editCustomsItemForm.controls.currency.setValue('USD');
            this.dialogRef.close(this.editCustomsItemForm.value);
            this.editCustomsItemForm.reset();
          },
          error: (err) => {
            this.toastr.error(
              'Error while getting exchange rate. Please use USD currency instead of EUR',
              'Error'
            );
          },
        });
      } else {
        this.editCustomsItemForm.controls.currency.enable();
        this.editCustomsItemForm.controls.currency.setValue('USD');
        this.dialogRef.close(this.editCustomsItemForm.value);
        this.editCustomsItemForm.reset();
      }
    }
  }
  ngOnDestroy(): void {
    this.editCustomsItemForm.reset();
  }

  searchContentNameB2B;
  contentHTSSelection = false;
  @ViewChild('searchElement') searchElement: ElementRef;
  focusOnInput() {
    setTimeout(() => {
      if (this.searchElement && this.searchElement.nativeElement) {
        this.searchElement.nativeElement.focus();
        this.searchElement.nativeElement.select();
      }
    }, 0);
  }
  startHTSContentSelection() {
    this.focusOnInput();
    this.contentHTSSelection = true;
  }
  selectHTSContent = (content) => {
    this.editCustomsItemForm.get('description').setValue(content?.content);
    this.editCustomsItemForm
      .get('hs_tariff_number')
      .setValue(content?.hts_code);
    this.searchContentNameB2B = '';
    this.contentHTSSelection = false;
  };
}
